import React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Task } from '../../types';
import '../add-task/AddTask.css';

interface TaskRecurrenceQuickModalProps {
    onChange: (recurrence?: Task['recurrence']) => void;
    onCustom: () => void;
    onClose: () => void;
}

export const TaskRecurrenceQuickModal: React.FC<TaskRecurrenceQuickModalProps> = ({ onChange, onCustom, onClose }) => {
    const { t } = useTranslation();
    const selectPreset = (unit: NonNullable<Task['recurrence']>['unit']) => {
        onChange({ unit, interval: 1, mode: 'fixed', pattern: 'interval' });
        onClose();
    };

    return createPortal(
        <div className="task-recurrence-modal-overlay" onClick={onClose}>
            <div className="task-recurrence-quick-modal" onClick={(event) => event.stopPropagation()}>
                <h4>{t('addTask.repeat')}</h4>
                <div className="task-recurrence-quick-options">
                    <button type="button" onClick={() => { onChange(undefined); onClose(); }}>{t('addTask.doesNotRepeat')}</button>
                    <button type="button" onClick={() => selectPreset('day')}>{t('addTask.daily')}</button>
                    <button type="button" onClick={() => selectPreset('week')}>{t('addTask.weekly')}</button>
                    <button type="button" onClick={() => selectPreset('month')}>{t('addTask.monthly')}</button>
                    <button type="button" onClick={() => selectPreset('year')}>{t('addTask.yearly')}</button>
                    <button type="button" className="custom" onClick={onCustom}>{t('addTask.custom')}</button>
                </div>
            </div>
        </div>,
        document.body,
    );
};
